import { useLocation } from "react-router-dom";
import CarrouselSponsored from "../components/carrouselSponsored/carrouselSponsored";

export default function CarrouselSponsoredPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const url = params.get("url");
  const momios = params.get("momios");
  const patrocinador = params.get("spon");
  const version= params.get("country");

  return (
    <CarrouselSponsored url={url} flagMomios={momios} patrocinador={patrocinador} version={version}/>
  )

}